/* Tells the database about logins and app opens (for owner Insights).
   Fire-and-forget: never blocks or breaks the app. */
import { config } from "../config";
import { getSupabase } from "./supabaseClient";

export function logActivity(action: "login" | "session_start" | "install_app"): void {
  if (config.useMockServices) return;
  try {
    void getSupabase().rpc("log_activity", { p_action: action }).then(() => undefined, () => undefined);
  } catch { /* ignore */ }
}
